import {
  GET_SMS_TEMPLATE_LIST,
  GET_SMS_TEMPLATE_LIST_SUCCESS,
  GET_SMS_TEMPLATE_LIST_FAIL,
  GET_SMS_TEMPLATE_DATA,
  GET_SMS_TEMPLATE_DATA_SUCCESS,
  GET_SMS_TEMPLATE_DATA_FAIL,
  ADD_SMS_TEMPLATE,
  ADD_SMS_TEMPLATE_SUCCESS,
  ADD_SMS_TEMPLATE_FAIL,
  UPDATE_SMS_TEMPLATE,
  UPDATE_SMS_TEMPLATE_SUCCESS,
  UPDATE_SMS_TEMPLATE_FAIL,
  DELETE_SMS_TEMPLATE,
  DELETE_SMS_TEMPLATE_SUCCESS,
  DELETE_SMS_TEMPLATE_FAIL,
  SEND_SMS_OUTBOUND,
  SEND_SMS_OUTBOUND_SUCCESS,
  SEND_SMS_OUTBOUND_FAIL,
  GET_SMS_ADDRESS_BOOK,
  GET_SMS_ADDRESS_BOOK_SUCCESS,
  GET_SMS_ADDRESS_BOOK_FAIL,
} from "./actionType";

// SMS Template List
export const getSmsTemplateList = () => ({
  type: GET_SMS_TEMPLATE_LIST,
});

export const getSmsTemplateListSuccess = (templates) => ({
  type: GET_SMS_TEMPLATE_LIST_SUCCESS,
  payload: templates,
});

export const getSmsTemplateListFail = (error) => ({
  type: GET_SMS_TEMPLATE_LIST_FAIL,
  payload: error,
});

// SMS Template Data
export const getSmsTemplateData = (templateId) => ({
  type: GET_SMS_TEMPLATE_DATA,
  payload: templateId,
});

export const getSmsTemplateDataSuccess = (template) => ({
  type: GET_SMS_TEMPLATE_DATA_SUCCESS,
  payload: template,
});

export const getSmsTemplateDataFail = (error) => ({
  type: GET_SMS_TEMPLATE_DATA_FAIL,
  payload: error,
});

// Add SMS Template
export const addSmsTemplate = (payload) => ({
  type: ADD_SMS_TEMPLATE,
  payload: payload,
});

export const addSmsTemplateSuccess = (template) => ({
  type: ADD_SMS_TEMPLATE_SUCCESS,
  payload: template,
});

export const addSmsTemplateFail = (error) => ({
  type: ADD_SMS_TEMPLATE_FAIL,
  payload: error,
});

// Update SMS Template
export const updateSmsTemplate = (payload) => ({
  type: UPDATE_SMS_TEMPLATE,
  payload: payload,
});

export const updateSmsTemplateSuccess = (template) => ({
  type: UPDATE_SMS_TEMPLATE_SUCCESS,
  payload: template,
});

export const updateSmsTemplateFail = (error) => ({
  type: UPDATE_SMS_TEMPLATE_FAIL,
  payload: error,
});

// Delete SMS Template
export const deleteSmsTemplate = (template) => ({
  type: DELETE_SMS_TEMPLATE,
  payload: template,
});

export const deleteSmsTemplateSuccess = (template) => ({
  type: DELETE_SMS_TEMPLATE_SUCCESS,
  payload: template,
});

export const deleteSmsTemplateFail = (error) => ({
  type: DELETE_SMS_TEMPLATE_FAIL,
  payload: error,
});

// Send SMS Outbound
export const sendSmsOutbound = (payload) => ({
  type: SEND_SMS_OUTBOUND,
  payload: payload,
});

export const sendSmsOutboundSuccess = (response) => ({
  type: SEND_SMS_OUTBOUND_SUCCESS,
  payload: response,
});

export const sendSmsOutboundFail = (error) => ({
  type: SEND_SMS_OUTBOUND_FAIL,
  payload: error,
});

// SMS Address Book
export const getSmsAddressBook = (payload) => ({
  type: GET_SMS_ADDRESS_BOOK,
  payload: payload,
});

export const getSmsAddressBookSuccess = (addressBook) => ({
  type: GET_SMS_ADDRESS_BOOK_SUCCESS,
  payload: addressBook,
});

export const getSmsAddressBookFail = (error) => ({
  type: GET_SMS_ADDRESS_BOOK_FAIL,
  payload: error,
});
